import React from 'react';
import { DefinitionListHorizontal, DefinitionListItem, DataOverview } from '@cp-shared-19/frontend-ui';
import { FinanceFinancialDetails } from 'cpes-common';
import { TranslationFormat, useTranslationWithFormatting } from 'localization/useTranslationWithFormatting';
import { EditStatus } from '../EditStatus';
import { NotificationForLastEditStatus } from './notification-for-last-edit-status/NotificationForLastEditStatus';
import { WithDefaultMarketApiErrors } from '@cp-shared-19/common-utilities';

export type DueDateConsultViewProps = {
    details: FinanceFinancialDetails;
    startEditing: () => void;
    lastEditStatus: WithDefaultMarketApiErrors<EditStatus>;
    upcomingDueDate?: string;
    isFinanceLeaseContract?: boolean;
};
export const ConsultView: React.FC<DueDateConsultViewProps> = ({
    details,
    startEditing,
    lastEditStatus,
    upcomingDueDate,
    isFinanceLeaseContract,
}) => {
    const { t, f } = useTranslationWithFormatting('financial-details');

    if (!details) {
        return null;
    }

    const isEditAllowed = !!details._links?.changeMonthlyDueDate && !isFinanceLeaseContract;

    const financeDueDateSectionItemList: DefinitionListItem[] = [
        {
            label: t('monthlyDueDateSection.consultView.label'),
            value: f(details.dueDate, TranslationFormat.NUMBER),
            tooltip: t('monthlyDueDateSection.consultView.tooltip'),
            labelId: t('monthlyDueDateSection.consultView.label'),
        },
    ].filter(item => !!item.value);

    return (
        <DataOverview
            titleLevel={5}
            title={t('monthlyDueDateSection.consultView.paymentDay')}
            buttonLabel={isEditAllowed ? t('monthlyDueDateSection.consultView.button.edit') : undefined}
            buttonProps={
                isEditAllowed
                    ? {
                          onClick: startEditing,
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          onKeyDown: (e: any) => e.key === 'Enter' && startEditing(),
                          testId: 'editButton',
                          disabled: !details._links?.changeMonthlyDueDate,
                          tabIndex: 0,
                      }
                    : undefined
            }
        >
            <DefinitionListHorizontal list={financeDueDateSectionItemList} />
            {!isFinanceLeaseContract && (
                <NotificationForLastEditStatus lastEditStatus={lastEditStatus} upcomingDueDate={upcomingDueDate} />
            )}
        </DataOverview>
    );
};
